import React, { useEffect, useRef, useState, useContext } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import "./GiftAutomation.css";
import WeExpress from "../home/WeExpress/WeExpress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import Talktous from "../Common-Component/Offcanvas/Talktous/Talktous";
import {
  Banners,
  Gratitude,
  allCategory,
  CustomerLove,
} from "../../utils/apis/master/Master";

const GiftAutomation = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [dataGratitude, setDataGratitude] = useState();
  const getAllDataGratitude = async () => {
    const res = await Gratitude();
    if (res?.success) {
      setDataGratitude(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllDataGratitude();
  }, []);

 
  return (
    <section className="GiftAutomation my-4">
      <div className="AboutusMain">
        <div className="custom_container">
          <Row>
            <Col lg={5}>
              <div className="aboutushead">
                <div className="heading_holder">
                  <span>
                    <b className="schedull">
                      " Always Appreciative, Automatically "
                    </b>
                  </span>
                  <p>Revolutionizing Corporate Gifting with Automation</p>
                </div>
                <div className="productCareinfo">
                  <p className="caretext">
                    In today's hectic business world, building strong
                    relationships with stakeholders, employees, and clients is
                    essential. This is made simple at <b>Mittal Craftworks</b>{" "}
                    by our innovative <b>Gift Automation Platform</b>.
                    <br /> <br />
                    Whether it's for client engagement, employee recognition, or
                    festive occasions, we ensure that gifting is effortless and
                    efficient.
                  </p>
                </div>
                {/* <div>
                  <p className="shedtext">
                    <FontAwesomeIcon icon={faCircleCheck} /> Schedule gifts to
                    go out on calendar-based employee occasions
                  </p>
                  <p className="shedtext">
                    <FontAwesomeIcon icon={faCircleCheck} /> Set up event-based
                    gifts in advance
                  </p>
                </div> */}
              </div>
            </Col>
            <Col lg={7}>
              <div className="RightImgcare">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assest/image/Gift_automation/gift-automation.png"
                  }
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="GiftAutomation_why_choose_us_section mb-5 automation-works">
        <div className="custom_container">
          <div className="this-make-sec">
            <div className="workHead">
              <h3>
                <span className="howtext">Our Gift Automation Platform</span>{" "}
                <br />
                <strong>Why Choose It?</strong>
              </h3>
            </div>

            <div className="row justify-content-center mt-5">
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="special-card">
                  

                  <div className="overlay-content">
                    <div className="row">
                      <div className="col-3">
                        <div className="number-div">
                          <h1 className="number">01</h1>
                        </div>
                      </div>
                      <div className="col-9 text-end">
                        <h1 className="ttt">Simplified Method for Giving</h1>
                        <p className="subcont">
                          Bid adieu to the hassle of selecting and sending gifts
                          by hand. Everything is automated by our technology,
                          from selecting the ideal present to guaranteeing
                          prompt delivery.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="special-card">
                

                  <div className="overlay-content">
                    <div className="row">
                      <div className="col-3">
                        <div className="number-div">
                          <h1 className="number">02</h1>
                        </div>
                      </div>
                      <div className="col-9 text-end">
                        <h1 className="ttt">Large-Scale Customized Touch</h1>
                        <p className="subcont">
                          Surprise recipients with personalised presents that
                          embody the principles of your company. Customize the
                          packaging, branding, and phrases to make each gift
                          genuinely unforgettable.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="special-card">
                 

                  <div className="overlay-content">
                    <div className="row">
                      <div className="col-3">
                        <div className="number-div">
                          <h1 className="number">03</h1>
                        </div>
                      </div>
                      <div className="col-9 text-end">
                        <h1 className="ttt">Numerous Choices</h1>
                        <p className="subcont">
                          Browse a wide selection of high-end presents,
                          including wellness kits, electronic devices, and
                          opulent hampers. We accommodate a range of tastes and
                          price ranges.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="special-card">
                 

                  <div className="overlay-content">
                    <div className="row">
                      <div className="col-3">
                        <div className="number-div">
                          <h1 className="number">04</h1>
                        </div>
                      </div>
                      <div className="col-9 text-end">
                        <h1 className="ttt">Tracking and Analytics</h1>
                        <p className="subcont">
                          Discover how your giving initiatives performed. For
                          optimum effect, monitor deliveries, gauge recipient
                          happiness, and adjust your strategy.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="automation-works">
        <div className="custom_container">
          <div className="workHead">
            <h3>
              <span className="howtext">How </span>
              <strong>
                Gift Automation <br /> Works
              </strong>
            </h3>
          </div>
          <div className="row PathsectionMain">
            <Col xl={8} md={8} className="mx-auto">
              <div className="pathImg">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assest/image/Gift_automation/pathImg1.png"
                  }
                />
                <Row>
                  <Col lg={4} md={4}>
                    <div className="automationtxt">
                      <h3>Set Up Your Campaign </h3>
                      <p>
                        Define the occasion, audience, and budget for your
                        gifting initiative.
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} md={4}>
                    <div className="automationtxt">
                      <h3>Personalise & AutomateYour Gift</h3>
                      <p>
                        Choose from our curated catalog, Add custom messages,
                        branding, and schedule delivery.
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} md={4}>
                    <div className="automationtxt">
                      <h3>Sit Back & Relax:</h3>
                      <p>
                        Our platform takes care of everything else, ensuring a
                        smooth and delightful gifting experience. tools, making
                        it easier to manage gifting programs without disrupting
                        your workflow.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
        </div>
      </div>

      <div className="NeedHelp">
        <div className="custom_container">
          <div className="Needhelpheading">
            <h3>
              <strong className="needhelp">Need Help</strong> With Gifting
              Programs?
            </h3>
            <div className="Talktousbtn">
              <Button className="btn" onClick={handleShow}>
                TALK TO US
              </Button>
            </div>
          </div>
        </div>
      </div>

      {dataGratitude?.length > 0 && <WeExpress data={dataGratitude} />}
      <Talktous
        show={show}
        handleClose={handleClose}
        placement="end"
        name="end"
      />
    </section>
  );
};

export default GiftAutomation;
